import styled from 'styled-components';

export const Wrapper = styled.section`
  font-size: 12px;
  line-height: 20px;
  margin: 20px 0;
`;

export const Info = styled.p`
  color: ${({ theme }) => theme.colors.primaryText};
  margin: 0;
`;

export const Button = styled.button`
  all: unset;
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
`;
